export const GET_SUPPORT_DETAILS_LIST_REQUEST = "GET_SUPPORT_DETAILS_LIST_REQUEST"
export const GET_SUPPORT_DETAILS_LIST_SUCCESS = "GET_SUPPORT_DETAILS_LIST_SUCCESS"

export const ADD_SUPPORT_DETAILS_REQUEST = "ADD_SUPPORT_DETAILS_REQUEST"
export const ADD_SUPPORT_DETAILS_SUCCESS = "ADD_SUPPORT_DETAILS_SUCCESS"

export const DELETE_SUPPORT_DETAILS_REQUEST = "DELETE_SUPPORT_DETAILS_REQUEST"
export const DELETE_SUPPORT_DETAILS_SUCCESS = "DELETE_SUPPORT_DETAILS_SUCCESS"
